module.exports = __webpack_public_path__ + "img/mbanner_sound.0a9567c2.png";